module.exports = __webpack_public_path__ + "static/media/image_19.bd4211da.png";